import maleDirectorImg from '../assets/images/team_male_director_1785522916658.png';
import femaleDirectorImg from '../assets/images/team_female_director_1785522930044.png';
import foundersDuoImg from '../assets/images/team_founders_epica_1785522941655.jpg';

const heroBgImg = 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?auto=format&fit=crop&q=80&w=2000';

import { Service, TeamMember, CaseStudy, PressClipping, Testimonial, PricingPlan } from '../types';

export const AGENCY_INFO = {
  name: "Épica Comunicaciones",
  tagline: "CONSULTORA DE COMUNICACIONES",
  headline: "Construimos historias que generan influencia",
  slogan: "Somos ÉPICA, una consultora de comunicación estratégica y posicionamiento digital. Transformamos mensajes en autoridad, reputación e influencia real.",
  description: "Somos ÉPICA, una consultora de comunicación estratégica y posicionamiento digital. Transformamos mensajes en autoridad, reputación e influencia real.",
  phone: "+56978373379",
  phone2: "+56988381569",
  phoneDisplay: "+56 9 7837 3379",
  phoneDisplay2: "+56 9 8838 1569",
  phoneDisplayCombined: "+56 9 7837 3379 / +56 9 8838 1569",
  whatsapp: "+56978373379",
  whatsappClean: "56978373379",
  email: "contacto@epicacomunicaciones.cl",
  emails: {
    general: "contacto@epicacomunicaciones.cl",
    angelica: "angelica.baeza@epicacomunicaciones.cl",
    alejandro: "alejandro.osorio@epicacomunicaciones.cl"
  },
  address: "Santiago, Chile",
  directorsNames: "Angélica Baeza y Alejandro Osorio",
  stats: [
    { value: "+14", label: "SECTORES" },
    { value: "360°", label: "ESTRATEGIA" },
    { value: "IA", label: "APLICADA" }
  ],
  heroBg: heroBgImg,
  foundersImg: foundersDuoImg,
};

export const SERVICES: Service[] = [
  {
    id: "posicionamiento-digital",
    title: "Posicionamiento Digital",
    shortDesc: "Estrategias SEO, presencia orgánica y arquitectura de contenidos para que tu marca lidere las conversaciones que importan.",
    fullDesc: "Creamos la estructura y presencia digital estratégica para que tu marca lidere su industria en motores de búsqueda, medios digitales y redes profesionales.",
    iconName: "Search",
    deliverables: [
      "Estrategia integral de SEO y posicionamiento orgánico",
      "Arquitectura de contenidos digitales B2B / B2C",
      "Auditoría de presencia web y autoridad de dominio",
      "Optimización de perfiles ejecutivos en redes profesionales",
      "Estrategia de palabras clave para nichos de alta competencia"
    ],
    benefits: [
      "Liderar las búsquedas orgánicas clave de tu sector",
      "Dominar las conversaciones digitales donde están tus clientes",
      "Construcción sostenida de autoridad de marca en internet"
    ],
    idealFor: "Organizaciones, marcas y líderes que buscan consolidar su autoridad digital y visibilidad orgánicamente.",
    highlightMetric: "Dominio de posicionamiento en búsquedas orgánicas clave en Chile."
  },
  {
    id: "comunicacion-estrategica",
    title: "Comunicación Estratégica",
    shortDesc: "Diseñamos narrativas y mensajes coherentes que alinean tus objetivos de negocio con la percepción pública.",
    fullDesc: "Definimos relatos sólidos e ingeniosos para conectar con audiencias estratégicas, alineando las metas de negocio con la reputación institucional.",
    iconName: "Target",
    deliverables: [
      "Diseño de arquitectura de mensajes y relatos de marca",
      "Estrategia de alineación narrativa corporativa",
      "Manual de posición y tono institucional",
      "Plan de relacionamiento con stakeholders y líderes",
      "Posicionamiento estratégico de voceros ejecutivos"
    ],
    benefits: [
      "Percepción pública totalmente alineada con la visión del negocio",
      "Relato claro, coherente y diferenciador frente a la competencia",
      "Consolidación de la reputación institucional a largo plazo"
    ],
    idealFor: "Empresas en etapa de expansión, directorios y marcas en proceso de transformación.",
    highlightMetric: "Estrategias personalizadas para líderes del mercado chileno."
  },
  {
    id: "produccion-de-contenidos",
    title: "Producción de Contenidos",
    shortDesc: "Contenido editorial, audiovisual y gráfico de alto impacto pensado para cada canal y audiencia.",
    fullDesc: "Producimos piezas editoriales y audiovisuales diseñadas con rigor periodístico para inspirar, educar e influir en tu ecosistema corporativo.",
    iconName: "Feather",
    deliverables: [
      "Redacción de columnas de opinión y artículos editoriales",
      "Producción de informes de industria y libros blancos (whitepapers)",
      "Creación de guiones y contenido audiovisual para redes",
      "Diseño gráfico editorial de alto impacto corporativo",
      "Contenidos adaptados para newsletter de liderazgo"
    ],
    benefits: [
      "Contenido de calidad periodística que genera engagement real",
      "Piezas listas para ser publicadas en canales de alta relevancia",
      "Historias potentes que mueven la conversación pública"
    ],
    idealFor: "Marcas corporativas, consultoras, firmas tecnológicas y gremios empresariales.",
    highlightMetric: "Formatos multiplataforma diseñados para impactar audiencias exigentes."
  },
  {
    id: "gestion-de-medios",
    title: "Gestión de Medios",
    shortDesc: "Relacionamiento con prensa, vocería y cobertura estratégica que amplifica tu voz en los medios correctos.",
    fullDesc: "Conectamos las novedades y visiones de tu organización con editores, periodistas y medios líderes en Chile y América Latina.",
    iconName: "Newspaper",
    deliverables: [
      "Relacionamiento continuo con salas de redacción y editores",
      "Redacción y distribución periodística de notas de prensa",
      "Gestión de entrevistas exclusivas en TV, Radio y Diarios",
      "Coordinación de puntos de prensa y encuentros con medios",
      "Monitoreo y reporte de cobertura con valorización mediática"
    ],
    benefits: [
      "Aparición en medios Tier 1 nacionales de alta credibilidad",
      "Amplificación de la voz corporativa en debates clave",
      "Relación fluida y transparente con periodistas de referencia"
    ],
    idealFor: "Organizaciones que buscan amplificar sus hitos, proyectos o posturas sectoriales.",
    highlightMetric: "Conexión directa con los periodistas y editores más influyentes del país."
  },
  {
    id: "reputacion-y-crisis",
    title: "Reputación y Crisis",
    shortDesc: "Monitoreo, prevención y manejo de crisis para proteger y fortalecer la reputación de tu organización.",
    fullDesc: "Protegemos el activo más valioso de tu empresa: su reputación. Diseñamos planes preventivos y actuamos con celeridad frente a contingencias activas.",
    iconName: "ShieldAlert",
    deliverables: [
      "Matriz de prevención de riesgos comunicacionales",
      "Comité de contención y gestión de crisis 24/7",
      "Redacción de comunicados oficiales y declaraciones públicas",
      "Monitoreo intensivo de prensa y entorno digital",
      "Simulacros y talleres de respuesta crítica para ejecutivos"
    ],
    benefits: [
      "Protección activa y contingencia inmediata del activo reputacional",
      "Gestión profesional para minimizar el impacto mediático negativo",
      "Acompañamiento directivo en momentos de alta tensión"
    ],
    idealFor: "Sectores regulados, empresas de servicios masivos, minería, finanzas y salud.",
    highlightMetric: "Célula estratégica 24/7 para el resguardo institucional."
  },
  {
    id: "ia-aplicada",
    title: "IA aplicada a la Comunicación",
    shortDesc: "Integramos inteligencia artificial para escalar contenidos, analizar datos y anticipar tendencias.",
    fullDesc: "Aprovechamos el potencial de la IA generativa y analítica para optimizar la creación de contenidos, monitorear la conversación y detectar oportunidades periodísticas antes que nadie.",
    iconName: "Cpu",
    deliverables: [
      "Generación y optimización asistida por IA de borradores de prensa",
      "Análisis predictivo de tendencias y temas de agenda",
      "Automatización de procesamiento de clipping y análisis de sentimiento",
      "Implementación de flujos de trabajo de IA para equipos de PR",
      "Modelos de IA para personalización de pitch comunicacional"
    ],
    benefits: [
      "Reducción dramática de tiempos de respuesta y producción",
      "Insights precisos basados en procesamiento de datos masivos",
      "Innovación de vanguardia aplicada a las comunicaciones corporativas"
    ],
    idealFor: "Equipos de comunicación modernos, agencias e industrias tecnológicas avanzadas.",
    highlightMetric: "Tecnología propia impulsada por modelos de inteligencia artificial."
  }
];

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: "presencia-digital",
    badge: "PUNTO DE PARTIDA",
    badgeType: "default",
    title: "Presencia Digital",
    price: "$450.000",
    period: "+ IVA / mensual",
    features: [
      "Gestión de redes sociales",
      "Calendario de contenidos",
      "Reporte mensual básico",
      "Línea gráfica coherente"
    ],
    ctaText: "Solicitar propuesta"
  },
  {
    id: "posicionamiento",
    badge: "CRECIMIENTO",
    badgeType: "default",
    title: "Posicionamiento",
    price: "$850.000",
    period: "+ IVA / mensual",
    features: [
      "Todo lo del plan anterior",
      "Estrategia de posicionamiento",
      "Producción de contenidos",
      "Optimización SEO"
    ],
    ctaText: "Solicitar propuesta"
  },
  {
    id: "autoridad-digital",
    badge: "MÁS ELEGIDO",
    badgeType: "popular",
    title: "Autoridad Digital",
    price: "$1.450.000",
    period: "+ IVA / mensual",
    isPopular: true,
    features: [
      "Estrategia integral 360°",
      "Vocería y liderazgo de opinión",
      "Gestión de medios",
      "Analítica avanzada"
    ],
    ctaText: "Solicitar propuesta"
  },
  {
    id: "reputacion-asuntos-publicos",
    badge: "ALTO IMPACTO",
    badgeType: "highlight",
    title: "Reputación y Asuntos Públicos",
    price: "$1.950.000",
    period: "+ IVA / mensual",
    features: [
      "Monitoreo de reputación",
      "Manejo de crisis",
      "Relacionamiento institucional",
      "Asuntos públicos"
    ],
    ctaText: "Solicitar propuesta"
  },
  {
    id: "influencia-digital",
    badge: "LIDERAZGO TOTAL",
    badgeType: "highlight",
    title: "Influencia Digital",
    price: "$2.500.000",
    period: "+ IVA / mensual",
    features: [
      "Programa de influencia completo",
      "IA aplicada a la comunicación",
      "Equipo dedicado",
      "Consultoría estratégica permanente"
    ],
    ctaText: "Solicitar propuesta"
  }
];

export const DIFFERENTIATORS = [
  {
    number: "01",
    title: "Estrategia primero",
    description: "No publicamos por publicar. Cada acción responde a un objetivo medible de negocio."
  },
  {
    number: "02",
    title: "Experiencia comprobada",
    description: "Un equipo con trayectoria en medios, comunicación política y corporativa."
  },
  {
    number: "03",
    title: "Contenido que influye",
    description: "Historias que construyen autoridad y mueven la conversación pública."
  },
  {
    number: "04",
    title: "Datos y tecnología",
    description: "Decisiones respaldadas por analítica e inteligencia artificial."
  },
  {
    number: "05",
    title: "Acompañamiento cercano",
    description: "Trabajamos como una extensión de tu equipo, no como un proveedor más."
  },
  {
    number: "06",
    title: "Resultados tangibles",
    description: "Reportamos con métricas claras: alcance, reputación e influencia real."
  }
];

export const METHODOLOGY_STEPS = [
  {
    number: "01",
    title: "Escuchamos",
    description: "Entendemos tu contexto, tus audiencias y tus desafíos.",
    icon: "HelpCircle"
  },
  {
    number: "02",
    title: "Analizamos",
    description: "Diagnóstico de reputación, competencia y oportunidades.",
    icon: "TrendingUp"
  },
  {
    number: "03",
    title: "Diseñamos",
    description: "Definimos la estrategia, narrativa y plan de acción.",
    icon: "Layers"
  },
  {
    number: "04",
    title: "Ejecutamos",
    description: "Implementamos con calidad y ritmo sostenido.",
    icon: "Zap"
  },
  {
    number: "05",
    title: "Medimos",
    description: "Evaluamos resultados con indicadores concretos.",
    icon: "PieChart"
  },
  {
    number: "06",
    title: "Evolucionamos",
    description: "Ajustamos y optimizamos para seguir creciendo.",
    icon: "Sparkles"
  }
];

export const SECTORS = [
  "Salud",
  "Educación",
  "Tecnología",
  "Retail",
  "Energía",
  "Minería",
  "Servicios Financieros",
  "Gobierno",
  "ONG y Fundaciones",
  "Inmobiliario",
  "Turismo",
  "Alimentos y Bebidas",
  "Startups",
  "Gremios y Asociaciones"
];

export const TEAM_MEMBERS: TeamMember[] = [
  {
    id: "angelica-baeza",
    name: "Angélica Baeza",
    role: "Directora de Comunicación Estratégica",
    bio: "Experta en estrategia de comunicación, reputación y relacionamiento institucional.",
    experience: "Trayectoria en medios y consultoría directiva",
    specialty: ["Estrategia Comunicacional", "Relaciones Institucionales", "Reputación Corporativa", "Gestión de Mensajes"],
    imageUrl: femaleDirectorImg,
    email: "angelica.baeza@epicacomunicaciones.cl"
  },
  {
    id: "alejandro-osorio",
    name: "Alejandro Osorio",
    role: "Director de Posicionamiento Digital",
    bio: "Especialista en posicionamiento, contenidos y transformación digital de marcas.",
    experience: "Transformación digital & contenidos",
    specialty: ["Posicionamiento Digital", "Arquitectura de Contenidos", "Estrategia SEO PR", "IA Aplicada"],
    imageUrl: maleDirectorImg,
    email: "alejandro.osorio@epicacomunicaciones.cl"
  }
];

export const CASE_STUDIES: CaseStudy[] = [
  {
    id: "case-fintech",
    title: "Lanzamiento y Posicionamiento de Neobanco FinTech en Chile",
    client: "Plataforma FinTech Regional",
    category: "fintech",
    challenge: "Ingresar a un mercado financiero altamente concentrado en Chile con cero notoriedad de marca y generar confianza para la adopción masiva.",
    solution: "Estrategia de PR basada en inclusión financiera, educación económica y vocería del CEO en diarios de negocios clave como Diario Financiero y El Mercurio.",
    results: {
      publications: 58,
      aveEstimate: "$145.000.000 CLP",
      tier1Media: ["Diario Financiero", "El Mercurio", "BíoBíoChile", "CNN Chile"]
    },
    quote: "Épica Comunicaciones logró instalarnos en la agenda económica de Chile en menos de 90 días. El impacto en nuestras métricas de captación fue contundente.",
    quoteAuthor: "Matías Silva",
    quoteRole: "CMO & Country Manager"
  },
  {
    id: "case-mineria",
    title: "Gestión de Crisis y Contingencia Socio-Ambiental",
    client: "Compañía Minera e Industrial",
    category: "mineria",
    challenge: "Afrontar un conflicto comunitario con riesgo de cobertura negativa imprecisa en televisión y prensa regional.",
    solution: "Despliegue de célula de respuesta inmediata 24/7 en terreno, elaboración de pauta de transparencia y gestión directa con salas de redacción.",
    results: {
      publications: 24,
      aveEstimate: "$85.000.000 CLP",
      tier1Media: ["TVN", "La Tercera", "El Mercurio de Antofagasta", "Radio Cooperativa"]
    },
    quote: "Su capacidad para mantener la calma y guiar nuestra vocería corporativa en el momento más complejo fue determinante para resguardar nuestra licencia social.",
    quoteAuthor: "Valentina Reyes",
    quoteRole: "Directora de Asuntos Corporativos"
  },
  {
    id: "case-tech",
    title: "Posicionamiento de Scale-up de Inteligencia Artificial",
    client: "Tech Enterprise LATAM",
    category: "tech",
    challenge: "Explicar el valor de la IA aplicada a la logística B2B a tomadores de decisión sin caer en tecnicismos irrelevantes.",
    solution: "Campaña de pensamiento de liderazgo (Thought Leadership) con notas de prensa enfocadas en eficiencias operativas y columnas de opinión firmadas por los fundadores.",
    results: {
      publications: 42,
      aveEstimate: "$110.000.000 CLP",
      tier1Media: ["Forbes Chile", "Bloomberg Línea", "Canal 13", "DF MAS"]
    },
    quote: "Transformaron nuestros datos técnicos en historias fascinantes para la prensa económica de Chile y la región.",
    quoteAuthor: "Rodrigo Morales",
    quoteRole: "Co-founder & CEO"
  }
];

export const PRESS_CLIPPINGS: PressClipping[] = [
  {
    id: "clip-1",
    mediaName: "El Mercurio",
    mediaLogo: "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?w=120&h=40&fit=crop&auto=format",
    headline: "Informe de Innovación Corporativa revela las nuevas tendencias en el sector chileno",
    date: "Ayer",
    category: "Economía y Negocios"
  },
  {
    id: "clip-2",
    mediaName: "Diario Financiero",
    mediaLogo: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=120&h=40&fit=crop&auto=format",
    headline: "Entrevista Exclusiva: Cómo la tecnología está transformando el Retail en Chile",
    date: "Hace 3 días",
    category: "Empresas"
  },
  {
    id: "clip-3",
    mediaName: "BíoBíoChile",
    mediaLogo: "https://images.unsplash.com/photo-1585829365295-ab7cd400c167?w=120&h=40&fit=crop&auto=format",
    headline: "Análisis: Los desafíos de la comunicación de crisis en la era de la inmediatez digital",
    date: "Hace 5 días",
    category: "Nacional"
  },
  {
    id: "clip-4",
    mediaName: "Forbes Chile",
    mediaLogo: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=120&h=40&fit=crop&auto=format",
    headline: "Las 10 startups chilenas que están redefiniendo el futuro del trabajo B2B",
    date: "Esta semana",
    category: "Negocios"
  }
];

export const MEDIA_OUTLETS = [
  "El Mercurio",
  "La Tercera",
  "Diario Financiero",
  "TVN",
  "Canal 13",
  "Mega",
  "Chilevisión",
  "Radio Bío-Bío",
  "Radio Cooperativa",
  "Forbes Chile",
  "Bloomberg Línea",
  "DF MÁS",
  "Ex-Ante",
  "Pauta.cl"
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: "test-1",
    author: "Camila Arancibia",
    position: "Directora de Marketing",
    company: "Grupo Inmobiliario & Desarrollo",
    comment: "ÉPICA no solo redacta notas de prensa; entienden el negocio. Lograron que cada lanzamiento apareciera en las portadas de los principales medios del país con un retorno de inversión muy superior a cualquier campaña pagada.",
    rating: 5
  },
  {
    id: "test-2",
    author: "Francisco Zúñiga",
    position: "Gerente General",
    company: "Empresa de Logística & Transporte",
    comment: "Cuando enfrentamos una contingencia operativa compleja, el equipo de ÉPICA estuvo disponible para coordinar nuestra respuesta. Su profesionalismo y templanza protegió años de reputación en pocas horas.",
    rating: 5
  },
  {
    id: "test-3",
    author: "María Paz Fuentes",
    position: "Head of Communications",
    company: "Scaleup de Salud & Telemedicina",
    comment: "La estrategia de posicionamiento de ÉPICA fue un antes y un después para nuestra organización. Salimos a medios con total seguridad y consolidamos nuestra autoridad sectorial.",
    rating: 5
  }
];

export const FAQS = [
  {
    question: "¿Qué diferencia a ÉPICA Comunicaciones de otras agencias tradicionales?",
    answer: "En ÉPICA combinamos la estrategia de comunicación con el posicionamiento digital, analítica e inteligencia artificial. Nuestros directores, Angélica Baeza y Alejandro Osorio, lideran cada proyecto con visión de negocio y sin rodeos."
  },
  {
    question: "¿Cómo se adaptan los planes a los objetivos de mi empresa?",
    answer: "Contamos con planes escalables desde Presencia Digital hasta Influencia Digital y Asuntos Públicos. Cada propuesta se personaliza según el momento de tu marca y las metas a alcanzar."
  },
  {
    question: "¿Trabajan con organizaciones de diferentes sectores?",
    answer: "Sí, contamos con experiencia en más de 14 sectores productivos e institucionales en Chile, desde salud, educación, minería y energía hasta startups tecnológicas y gremios."
  },
  {
    question: "¿Cómo puedo agendar una reunión inicial?",
    answer: "Puedes agendar directamente a través del formulario de contacto en nuestro sitio o enviando un correo a contacto@epicacomunicaciones.cl para coordinar una sesión estratégica."
  }
];
